import apiList from "@/service/basic/orderReportApi";
import { api, postForm } from "@/service/api";
const myhost = echarthostname;

// 休店申请列表
export function getOffList(params = {}) {
  return new Promise((resolve, reject) => {
    api
      .get(`${myhost}${apiList.getOffList}`, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 休店枚举
export function getReasonEnum() {
  return new Promise((resolve, reject) => {
    api
      .get(`${myhost}${apiList.getReasonEnum}`)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 休店申请（提交）
export function postOffStore(params = {}) {
  return new Promise((resolve, reject) => {
    api
      .post(`${myhost}${apiList.postOffStore}`, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 当前店铺状态信息
export function getCurrentStatus() {
  return new Promise((resolve, reject) => {
    api
      .get(`${myhost}${apiList.getOffStatus}`)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// ------------------- 发货规则 -------------------

// 当前店铺发货规则信息
export function getCurrentDetail() {
  return new Promise((resolve, reject) => {
    api
      .get(`${myhost}${apiList.getRuleDetail}`)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 发货列表
export function getRuleLists(params = {}) {
  return new Promise((resolve, reject) => {
    api
      .get(`${myhost}${apiList.getRuleList}`, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 发货规则（提交）
export function postRules(params = {}) {
  return new Promise((resolve, reject) => {
    api
      .post(`${myhost}${apiList.submitRule}`, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// ------------------- 报备 -------------------
// 延迟发货原因枚举
export function getDelayEnum() {
  return new Promise((resolve, reject) => {
    api
      .get(`${myhost}${apiList.getDelayEnum}`)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}
// 状态枚举
export function getStatusEnum() {
  return new Promise((resolve, reject) => {
    api
      .get(`${myhost}${apiList.getStatusEnum}`)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 报备列表
export function getReportLists(params = {}) {
  return new Promise((resolve, reject) => {
    api
      .get(`${myhost}${apiList.getReportList}`, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 报备申请（提交）
export function postReportApply(params = {}) {
  return new Promise((resolve, reject) => {
    api
      .post(`${myhost}${apiList.submitReport}`, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}
// 报备申请（撤消）
export function cancelReportApply(params = {}) {
  return new Promise((resolve, reject) => {
    api
      .post(`${myhost}${apiList.cancelReport}`, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}
// 报备详情
export function getReportDetail(params = {}) {
  return new Promise((resolve, reject) => {
    api
      .get(`${myhost}${apiList.getReportDetail}`, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}
// 报备 - 受影响订单
export function getOrderList(params = {}) {
  return new Promise((resolve, reject) => {
    api
      .get(`${myhost}${apiList.orderList}`, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 图片上传
export function uploadImg(params = {}) {
  return postForm(`${myhost}${apiList.uploadImage}`, params);
}

// 文件上传
export function uploadOrder(params = {}) {
  return new Promise((resolve, reject) => {
    api
      .post(`${myhost}${apiList.uploadOrder}`, params)
      .then(res => {
        if (res) {
          resolve(res.data);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
}



// WEBPACK FOOTER //
// ./src/models/orderReportModel.js